module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/2cd3e62c68b5bfca3e70a2cd2d108e9b.svg";